import React, { useEffect, useState } from "react";

import {
	BackspaceButton,
	BannerForShimmer,
	PrevBtn,

} from "../../utils/SvgComponents";
import toast from "react-hot-toast";
import { getDataFromStore, storeInData } from "../../utils/CookiesUtils";
import { AUTH_TOKEN_KEY, EVENT_BASEURL, LOGIN_DATA } from "../../utils/Constants";
import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "../common/button/Button";
import RippleInitializer from "../new-pages/RippleInitializer";
import { apiHandler } from "../../utils/apiHandler";

const Login = () => {
	const [isFound, setFound] = useState(true);
	const [pin, setPin] = useState("");
	const [showPinCode, setShowPinCode] = useState(false);
	const [loginData, setLoginData] = useState(null);
	const [isBlured, setIsBlurred] = useState(true)
	const [data, setData] = useState([])
	const navigate = useNavigate();
	const { username } = useParams();
	const pathParts = window.location.pathname.split("/").filter(Boolean);
	const isAuthenticated = getDataFromStore(AUTH_TOKEN_KEY);
	let usernamenew = "";

	const pathArray = window.location.pathname.split("/").filter(Boolean);

	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		usernamenew = pathArray[1];
	} else {
		usernamenew = pathArray[0]
	}


	useEffect(() => {
		const interval = setInterval(() => {
			const stored = localStorage.getItem(`logindata_${usernamenew}`);
			console.log('hii')
			if (stored) {
				setLoginData(JSON.parse(stored));
				setFound(true);
				clearInterval(interval);
			}
		}, 100); // check every 100ms

		return () => clearInterval(interval);
	}, [usernamenew]);

	useEffect(() => {
		// Unblur after 1 second (adjust delay as needed)
		const timer = setTimeout(() => {
			setIsBlurred(false);
		}, 200);

		// Cleanup timer on unmount
		return () => clearTimeout(timer);
	}, []);

	localStorage.removeItem("confettiShown");
	localStorage.removeItem('scrollPosition')
	// Handle URL updates and back navigation
	useEffect(() => {
		const onBackButtonPress = (e) => {
			if (showPinCode) {
				e.preventDefault();
				setShowPinCode(false);
				setPin("");
				// navigate(`/Login/reetika&chandresh2`);
			}
		};

		window.addEventListener("popstate", onBackButtonPress);
		return () => {
			window.removeEventListener("popstate", onBackButtonPress);
		};
	}, [showPinCode, navigate, username]);

	useEffect(() => {
		// if (showPinCode) {
		// 	window.history.pushState({}, "", "/Login/reetika&chandresh2");
		// 	// navigate(`/Login/reetika&chandresh2`, { replace: false });
		// 	console.log("working")
		// } else {
		// 	window.history.pushState({}, "", "/Login/reetika&chandresh2");
		// 	// navigate(`/Login/reetika&chandresh2`, { replace: true });
		// 	setShowPinCode(false);
		// }
	}, [showPinCode, username]);

	useEffect(() => {
		const fetchGuestLogin = async () => {
			try {
				const res = await apiHandler.post("/guest/login", {
					title: `https://wedding-patrika/${username}`,
				});
				if (res.data) {
					setFound(true);
					setLoginData(res.data);
				}
			} catch (err) {
				setFound(false);
				console.error("Guest login error:", err);
				window.location.href = "https://weddingpatrika.com";
			}
		};





		// fetchGuestLogin();
	}, [])

	const redirectToPage =
		localStorage.getItem(`redirectToPage_${username}`)
			?.split("/")
			.filter(Boolean) || [];


	useEffect(() => {

		const fetchDashBoard = async (e) => {


			try {

				const res = await apiHandler.post("/guest/dashboard", {
					// eventId: getLoginData?._id,
				});
				setData(res)

			} catch (err) {
				console.error("Guest login error:", err);
			}
		};
		if (data.length === 0) {
			// fetchDashBoard();
		}
	}, [loginData])






	const handlePin = (value) => {
		if (pin.length >= 6) return;
		if (value !== "back") {
			const newValue = pin + value;
			setPin(newValue);
		}
	};

	const handleRemovePin = () => {
		const newPin = pin.slice(0, -1);
		setPin(newPin);
	};
	console.log(redirectToPage?.length)
	const joinEvent = () => {
		if (pin.length !== 6) {
			toast("Please enter 6 digit pin!", { id: "Error" });
			return;
		}
		else if (redirectToPage?.length >= 3 && pin === loginData.eventPasscode) {
			console.log(redirectToPage.length)
			if (redirectToPage?.length === 4) {
				localStorage.setItem(`AUTH_TOKEN_KEY_${loginData?.eventURL}`, "Success")
				localStorage.setItem(`logindata_${loginData?.eventURL}`, JSON.stringify(loginData))
				localStorage.setItem(`animationsEnabled_${loginData?.eventURL}`, "true")
				navigate(`/${redirectToPage[0]}/${redirectToPage[1]}/${redirectToPage[2]}/${redirectToPage[3]}`);
			}
			else {
				localStorage.setItem(`AUTH_TOKEN_KEY_${loginData?.eventURL}`, "Success")
				localStorage.setItem(`logindata_${loginData?.eventURL}`, JSON.stringify(loginData))
				localStorage.setItem(`animationsEnabled_${loginData?.eventURL}`, "true")
				navigate(`/${redirectToPage[0]}/${redirectToPage[1]}/${redirectToPage[2]}`);
			}
		}
		else if (pin === loginData.eventPasscode) {
			localStorage.setItem(`AUTH_TOKEN_KEY_${loginData?.eventURL}`, "Success")
			localStorage.setItem(`logindata_${loginData?.eventURL}`, JSON.stringify(loginData))
			localStorage.setItem(`animationsEnabled_${loginData?.eventURL}`, "true")
			navigate(`/${username}`);
		} else {
			toast("Please enter Valid Pin Code.!", { id: "Error" });
		}


	};

	const handlePinKey = (e) => {
		const { value } = e.target;
		if (value.length > 6) return;
		setPin(value);
	};
	return (
		<div>
			<div className="hidden sm:block h-screen">
				<div className="grid grid-cols-3">
					<div className="bg-black text-white text-center flex flex-col justify-around items-center py-3 h-screen overflow-x-auto scroll-bar">
						<div className="style-script-regular font-Baby_Giovani_Script text-[50px]">
							Enter Passcode
						</div>
						<input
							className="underline text-center underline-offset-[12px] leading-[50px] tracking-[8px] text-[26px] font-Lemon focus-visible:outline-none bg-transparent border-transparent"
							type="text"
							value={pin}
							onChange={(e) => handlePinKey(e)}
							name=""
							id=""
						/>
						{/* <div className="underline underline-offset-[12px] tracking-[8px] text-[26px] font-Lemon h-[50px]">
                            {pin}
                        </div> */}
						<div className="grid grid-cols-3 gap-7 my-2">
							{[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
								<CustomButton
									key={item}
									bgColor="rgb(255 255 255 / 0.2)"
									borderRadius="100%"
									width="70px"
									height="70px"
									fontSize="24px"
									paddingX="16px"
									paddingY="16px"
									className={`transition-all duration-500 ${isBlured ? "blur-lg scale-105" : "blur-0 scale-100"
										} mx-auto w-[70px] aspect-square  text-[24px] text-white rounded-full bg-white/20 cursor-pointer p-4 transition-transform duration-200 ease-in-out active:scale-95`}
									clicked={() => handlePin(item)}
								>
									<span className="lemon-font">{item}</span>
								</CustomButton>
							))}
							<div></div>
							<CustomButton
								bgColor="rgb(255 255 255 / 0.2)"
								borderRadius="100%"
								width="70px"
								height="70px"
								fontSize="24px"
								paddingX="16px"
								paddingY="16px"
								className={`transition-all duration-500 ${isBlured ? "blur-lg scale-105" : "blur-0 scale-100"
									} mx-auto w-[70px] aspect-square  text-[24px] text-white rounded-full bg-white/20 cursor-pointer p-4 transition-transform duration-200 ease-in-out active:scale-95`} clicked={() => handlePin(0)}
							>
								<span className={`lemon-font transition-all duration-500 ${isBlured ? "blur-lg scale-105" : "blur-0 scale-100"
									}`}>0</span>
							</CustomButton>
							<CustomButton
								bgColor="rgb(0 0 0 / 0.75)"
								borderRadius="100%"
								width="70px"
								height="70px"
								fontSize="23px"
								paddingX="16px"
								paddingY="16px"
								className="mx-auto w-[70px] aspect-square text-white rounded-full p-3 cursor-pointer scale-[1] active:scale-[0.95] active:bg-white/25 focus:bg-white/25"
								clicked={() => handleRemovePin()}
							>
								<BackspaceButton fill="white" />
							</CustomButton>
						</div>
						<button
							id="join-event"
							bgColor="rgb(0 0 0 / 0.75)"
							borderRadius="14px"
							border="2px solid white"
							width="52%"
							fontSize="23px"
							paddingX="8px"
							paddingY="5px"
							style={{
								border: '2px solid white'
							}}
							className="uppercase whiteripple bg-black/75  border-white font-medium w-[52%] min-h-12 py-[7px] px-2 text-[23px] rounded-xl "
							onClick={() => joinEvent()}
						>

							<span className="common-font tracking-[0.3px] ">Join Event</span>
							<RippleInitializer />
						</button>
						<div className="uppercase text-[20px] font-medium">
							Want to make your event invite ?
						</div>
					</div>
					<div className="col-span-2 relative">
						<img
							src={loginData && `https://welcometowedding.com/events/${loginData?._id}/${loginData?.eventWebLockscreen}
							
							`}
							className={`h-screen w-full transition-all duration-500 ${isBlured ? "blur-lg scale-105" : "blur-0 scale-100"
								}`}
							alt=""
						/>
						<div className="w-full text-center px-[80px] py-[20px] absolute bottom-0 bg-black/60">
							<span className="text-white font-Baby_Giovani_Script text-[50px] style-script-regular">
								{loginData && loginData?.eventTitle}
							</span>
							<div className="px-[150px]">
								<BannerForShimmer eventDate={loginData?.eventDate} />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="block sm:hidden sm:pointer-events-none relative h-[100svh] overflow-hidden">
				<div
					className={`w-screen h-full bg-cover bg-center transition-all duration-500 ${isBlured ? "blur-lg scale-105" : "blur-0 scale-100"
						}`}
					style={{
						backgroundImage: loginData?.eventMobLockscreen
							? `url("https://welcometowedding.com/events/${loginData?._id}/${loginData?.eventWebLockscreen}")`
							: 'none'
					}}
				>
					<div className="bg-black/50 w-full h-full text-center text-white flex flex-col justify-end items-center">
						{loginData && <p className="font-Baby_Giovani_Script text-[60px] leading-snug m-0 style-script-regular">
							{loginData?.eventTitle.split('&')[0]}
							<br />&<br />
							{loginData?.eventTitle.split('&')[1]}
						</p>}
						<div className="w-[80%] mx-auto">
							<BannerForShimmer eventDate={loginData?.eventDate} />
						</div>
						<button
							bgColor="rgb(0 0 0 / 0.75)"
							borderRadius="14px"
							width="85%"
							border="2px solid white"
							fontSize="20px"
							paddingX="8px"
							paddingY="8px"
							marginY="25px"
							style={{
								border: '2px solid white'
							}}
							className={
								"whiteripple uppercase bg-black/75 border-2 border-white p-2 w-[85%] min-h-12 my-[25px] text-[20px] rounded-xl cursor-pointer "
							}
							onClick={() => setShowPinCode(true)}
						>
							Join Event
						</button>
						<p className="bg-black uppercase w-full py-[10px] text-[18px] mb-0">
							Want to make your event invite ?
						</p>
					</div>
				</div>
				<div

					className={`w-screen h-full bg-cover bg-center absolute top-0 ease-in-out duration-200 ${showPinCode ? "scale-1 opacity-100" : "scale-125 opacity-0 pointer-events-none"
						}`}

					style={{
						backgroundImage: loginData?.eventMobLockscreen
							? `url("https://welcometowedding.com/events/${loginData?._id}/${loginData?.eventWebLockscreen}")`
							: 'none'
					}}
				>
					<div className="w-full h-full bg-black/50 backdrop-filter backdrop-blur-2xl text-white text-center flex flex-col justify-around items-center py-2 overflow-x-auto scroll-bar">
						<div className="">
							<div className="relative font-Baby_Giovani_Script text-[45px] style-script-regular">
								<CustomButton
									className="absolute top-0 left-0 me-3 rounded-full aspect-square w-[50px] scale-[1] active:scale-[0.95] "
									clicked={() => setShowPinCode(false)}
								>
									<div className="pb-3 ">
										<PrevBtn
											fill="white"
											width="40"
											height="40"
										/>
									</div>
								</CustomButton>
								Enter Passcode
							</div>
						</div>
						<div className="underline underline-offset-[12px] tracking-[8px] text-[26px] font-Lemon h-[50px]">
							{pin}
						</div>
						<div>

							<div className=" grid grid-cols-3 gap-7 my-2">
								{[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
									<button
										key={item}
										bgColor="rgb(255 255 255 / 0.2)"
										borderRadius="100%"
										width="70px"
										height="70px"
										fontSize="24px"
										paddingX="16px"
										paddingY="16px"
										className={`transition-all duration-500 ${isBlured ? "blur-lg scale-105" : "blur-0 scale-100"
											} mx-auto w-[70px] aspect-square font-Lemon text-[24px] text-white rounded-full bg-white/20 cursor-pointer p-3 scale-[1] active:scale-[0.95]`}
										onClick={() => handlePin(item)}
									>
										{item}
									</button>
								))}
								<div></div>
								<CustomButton
									bgColor="rgb(255 255 255 / 0.2)"
									borderRadius="100%"
									width="70px"
									height="70px"
									fontSize="24px"
									paddingX="16px"
									paddingY="16px"
									className={`transition-all duration-500 ${isBlured ? "blur-lg scale-105" : "blur-0 scale-100"
										} mx-auto w-[70px] aspect-square font-Lemon text-[24px] text-white rounded-full bg-white/20 cursor-pointer p-4 scale-[1] active:scale-[0.95]`}
									clicked={() => handlePin(0)}
								>
									0
								</CustomButton>
								<div
									// bgColor="rgb(255 255 255 / 0.2)"
									borderRadius="100%"
									width="70px"
									height="70px"
									fontSize="24px"
									paddingX="16px"
									paddingY="16px"
									className="mx-auto w-[70px] aspect-square text-white rounded-full p-3 cursor-pointer scale-[1] active:scale-[0.95] active:bg-white/25 focus:bg-white/25"
									onClick={() => handleRemovePin()}
								>
									<BackspaceButton fill="white" />
								</div>
							</div>
						</div>
						<button
							bgColor="rgb(0 0 0 / 0.75)"
							borderRadius="14px"
							border="2px solid white"
							width="82%"
							fontSize="20px"
							paddingX="8px"
							paddingY="8px"
							marginY="25px"
							style={{
								border: '2px solid white'
							}}
							className="uppercase bg-black/75 border-2 border-white p-2 w-[85%] min-h-12 my-[25px] text-[20px] rounded-xl whiteripple"
							onClick={() => joinEvent()}
						>
							Join Event
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};


// const notUserFound = () => {
// 	return (
// 		<div className="flex items-center justify-center h-screen bg-gradient-to-br from-purple-600 ... ... to-indigo-600">
// 			<div className="text-center text-white">
// 				<h1 className="text-6xl mb-4 font-bold">Sorry!</h1>
// 				<p className="text-2xl mb-4">
// 					The link you're trying to access doesn't exist or has expired.
// 				</p>
// 				<p className="text-lg">
// 					Please check the URL or contact the couple for the correct invitation link.
// 				</p>
// 			</div>
// 		</div>
// 	)
// }

export default Login;
